import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, Button } from '@ncoder/ui';
import { Play, BarChart3, TestTube } from 'lucide-react';

interface QuickActionsPanelProps {
  onRunQuickTest?: () => void;
  onViewAnalytics?: () => void;
  onCustomTestSuite?: () => void;
}

export const QuickActionsPanel: React.FC<QuickActionsPanelProps> = ({
  onRunQuickTest,
  onViewAnalytics,
  onCustomTestSuite,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={onRunQuickTest}
        >
          <Play className="h-4 w-4 mr-2" />
          Run Quick Test
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={onViewAnalytics}
        >
          <BarChart3 className="h-4 w-4 mr-2" />
          View Analytics
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={onCustomTestSuite}
        >
          <TestTube className="h-4 w-4 mr-2" />
          Custom Test Suite
        </Button>
      </CardContent>
    </Card>
  );
};
